import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Vehicles from '../components/Vehicles';
import Testimonials from '../components/Testimonials';
import About from '../components/About';
import FAQ from '../components/FAQ';

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://limousine-vip-paris.fr/"
    }
  ]
};

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>VIP Limousine Paris - Location de Limousine avec Chauffeur 24/7 | Île-de-France</title>
        <meta name="description" content="VIP Limousine Paris ★ Location de limousine avec chauffeur privé à Paris et en Île-de-France. Mariages, transferts aéroport CDG/Orly, soirées VIP, EVJF. Rolls Royce, Hummer stretch. Réservation 24/7. Devis gratuit." />
        <link rel="canonical" href="https://limousine-vip-paris.fr/" />

        <meta property="og:title" content="VIP Limousine Paris - Location de Limousine avec Chauffeur 24/7" />
        <meta property="og:description" content="Service premium de limousine de luxe à Paris. Mariages, aéroport, soirées VIP." />
        <meta property="og:url" content="https://limousine-vip-paris.fr/" />

        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <section id="accueil">
        <Hero />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="vehicules">
        <Vehicles />
      </section>

      <section id="temoignages">
        <Testimonials />
      </section>

      <section id="a-propos">
        <About />
      </section>

      <section id="faq">
        <FAQ />
      </section>
    </>
  );
};

export default HomePage;
